import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ManifestState {
    isLoading: boolean;
    currencySymbol: string;
}

export const initialState: ManifestState = {
    isLoading: false,
    currencySymbol: ''
};

const manifestSlice = createSlice({
    name: 'manifest',
    initialState,
    reducers: {
        startRequest: state => {
            state.isLoading = true;
        },
        endRequest: state => {
            state.isLoading = false;
        },
        setCurrencySymbol: (state, action: PayloadAction<string>) => {
            state.currencySymbol = action.payload;
        }
    }
});

export const { startRequest, endRequest, setCurrencySymbol } = manifestSlice.actions;
export default manifestSlice.reducer;
